module.exports = __webpack_public_path__ + "img/SEJ enventos_registro de ct.192d67c5.svg";